module.exports = __webpack_public_path__ + "static/media/Toad.a79f7a71.gif";